import React, { ReactElement } from 'react';

import { Col, Divider, Form, Layout, Row, TypographyText } from '@components/atoms';
import InputField from '@components/molecules/InputField';
import { MAIN_SYMPTOM_GUIDE_1, MAIN_SYMPTOM_PLACEHOLDER, MAIN_SYMPTOM_TITLE } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';
import { getSurveyObj } from '@utils/surveyUtils';

function MainSymptom(): ReactElement {
  const { form, formData, formFieldsError, validationChecker, setFormData } = useReduxForm('survey');
  const { selectedMainSurveyCode } = formData;
  return (
    <Layout>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{MAIN_SYMPTOM_TITLE}</TypographyText>
        </Col>
      </Row>
      {selectedMainSurveyCode !== 0 ? (
        <>
          <Divider margin={2} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
          <Row>
            <Col yzTypeCol="center">
              <TypographyText yzTypeTypographyText="basic">
                {`<${getSurveyObj(selectedMainSurveyCode).label}>`}
              </TypographyText>
            </Col>
          </Row>
        </>
      ) : (
        <Divider margin={6} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      )}
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{MAIN_SYMPTOM_GUIDE_1}</TypographyText>
        </Col>
      </Row>
      <Divider margin={7.5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col style={{ width: '100%' }} yzTypeCol="center">
          <Form
            form={form}
            initialValues={{ mainSymptom: formData?.mainSymptom ?? '' }}
            labelAlign="left"
            style={{
              width: '100%',
            }}
          >
            <InputField
              borderTop={false}
              componentArray={[
                {
                  type: 'textArea',
                  yzTypeTextArea: 'form',
                  placeholder: MAIN_SYMPTOM_PLACEHOLDER,
                  dataIndex: 'mainSymptom',
                  formData,
                  onChange: (e: any) => {
                    setFormData('mainSymptom', e);
                  },
                },
              ]}
              formFieldsError={formFieldsError}
              validation={validationChecker}
            />
          </Form>
        </Col>
      </Row>
      <Divider margin={38} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
    </Layout>
  );
}

export default MainSymptom;
